import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type ContentHeaderProps = ComponentProps<'div'>;

export function ContentHeader({ className, ...props }: ContentHeaderProps) {
  return (
    <div
      className={twMerge(
        'flex flex-shrink-0 flex-col items-center justify-center py-4 shadow-lg',
        className,
      )}
      {...props}
    />
  );
}
